"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var scrollable_1 = require("./scrollable/scrollable");
var bidi_1 = require("@angular/cdk/bidi");
var platform_1 = require("@angular/cdk/platform");
var fixed_size_virtual_scroll_1 = require("./fixed-size-virtual-scroll/fixed-size-virtual-scroll");
var sis_virtual_scroll_viewport_component_1 = require("./virtual-scroll-viewport/sis-virtual-scroll-viewport.component");
var virtual_for_of_1 = require("./virtual-for-of/virtual-for-of");
var scroll_dispatcher_1 = require("./scroll-dispatcher/scroll-dispatcher");
var viewport_ruler_1 = require("./viewport-ruler/viewport-ruler");
var SisScrollableModule = /** @class */ (function () {
    function SisScrollableModule() {
    }
    SisScrollableModule = __decorate([
        core_1.NgModule({
            exports: [scrollable_1.SisScrollable],
            declarations: [scrollable_1.SisScrollable]
        })
    ], SisScrollableModule);
    return SisScrollableModule;
}());
exports.SisScrollableModule = SisScrollableModule;
/**
 * @docs-primary-export
 */
var ScrollingModule = /** @class */ (function () {
    function ScrollingModule() {
    }
    ScrollingModule = __decorate([
        core_1.NgModule({
            imports: [
                bidi_1.BidiModule,
                platform_1.PlatformModule,
                SisScrollableModule
            ],
            exports: [
                bidi_1.BidiModule,
                SisScrollableModule,
                fixed_size_virtual_scroll_1.SisFixedSizeVirtualScroll,
                virtual_for_of_1.SisVirtualForOf,
                sis_virtual_scroll_viewport_component_1.SisVirtualScrollViewportComponent,
            ],
            declarations: [
                fixed_size_virtual_scroll_1.SisFixedSizeVirtualScroll,
                virtual_for_of_1.SisVirtualForOf,
                sis_virtual_scroll_viewport_component_1.SisVirtualScrollViewportComponent,
            ],
            providers: [
                scroll_dispatcher_1.ScrollDispatcher,
                viewport_ruler_1.ViewportRuler
            ]
        })
    ], ScrollingModule);
    return ScrollingModule;
}());
exports.ScrollingModule = ScrollingModule;
//# sourceMappingURL=scrolling.module.js.map